<template>
  <div class="made-order">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入商品订单号/用户..."></Input>
          </FormItem>
          <FormItem>
            <Select
              v-model="formItem.order_status"
              :style="{'width':'150px'}"
              placeholder="选择退款状态..."
              clearable
            >
              <Option
                v-for="item in orderStatusList"
                :value="item.value"
                :key="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <DatePicker
              type="datetimerange"
              format="yyyy-MM-dd"
              @on-change="changeDate"
              style="width: 260px"
              placeholder="下单时间"
            ></DatePicker>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>&nbsp;
            <Button type="success" :loading="exportLoading" @click="exportOrder()">导出订单</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table
      max-height="600"
      border
      :columns="list"
      :data="tablelist"
      :loading="dataloading"
      class="B2CList"
    ></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.current"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
  </div>
</template>

<script>
// import expandRow from "./table-expand";

export default {
  name: "made-order",
  data() {
    return {
      orderStatusList: [
        { value: 0, label: "未退款" },
        { value: 1, label: "退款中" },
        { value: 2, label: "已完成" }
      ],
      dataloading: true,
      formItem: {
        key: "",
        order_status: "",
        datetime: []
      },
      pages: {
        current: 1,
        total: 0,
        size: 10
      },
      list: [
        {
          title: "id",
          key: "id",
          width: 80
          // fixed:"left"
        },
        {
          title: "订单号",
          key: "order_num",
          width: 185,
          render: (h, params) => {
            return h("span", params.row.magnhegoodorder.order_num);
          }
        },
        {
          title: "下单用户",
          width: 120,
          render: (h, params) => {
            return h(
              "span",
              params.row.user != null ? params.row.user.username : ""
            );
          }
        },
        {
          title: "商品id",
          width: 80,
          render: (h, params) => {
            return h("span", params.row.poolgooddata.good_id);
          }
        },
        {
          title: "商品名称",
          width: 120,
          render: (h, params) => {
            return h("span", params.row.poolgooddata.title);
          }
        },
        {
          title: "盲盒订单号",
          width: 185,
          render: (h, params) => {
            return h("span", params.row.boxorder.pay_order_num);
          }
        },
        {
          title: "退款状态",
          width: 100,
          align: "center",
          key: "order_status",
          render: (h, params) => {
            return h(
              "div",
              params.row.order_status == 0
                ? "未退款"
                : params.row.order_status == 1
                ? "退款中"
                : "已完成"
            );
          }
        },
        {
          title: "退款方式",
          width: 100,
          align: "center",
          key: "pay_type",
          render: (h, params) => {
            return h("div", params.row.pay_name);
          }
        },
        {
          title: "付款金额",
          width: 100,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.magnhegoodorder.price);
          }
        },
        {
          title: "回收比例",
          width: 100,
          align: "center",
          key: "recovery_bili"
        },
        {
          title: "退款金额",
          width: 100,
          align: "center",
          key: "recovery_money"
        },
        {
          title: "回收时间",
          width: 150,
          align: "center",
          key: "created_at"
        },
        {
          title: "退款时间",
          width: 150,
          align: "center",
          key: "updated_at"
        }
        // {
        //   title: "操作",
        //   align: "center",
        //   key: "action",
        //   width: 150,
        //   // fixed: 'right',
        //   render: (h, params) => {
        //     return h("div", [
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "primary",
        //             size: "small"
        //           },
        //           style: {
        //             marginRight: "5px",
        //             display:
        //               params.row.order_status == "1" &&
        //               params.row.pay_status < 3
        //                 ? "inline-block"
        //                 : "none"
        //           },
        //           on: {
        //             click: () => {
        //               this.cancelorder(params.row.id);
        //             }
        //           }
        //         },
        //         "详情"
        //       )
        //     ]);
        //   }
        // }
      ],
      tablelist: [],
      exportLoading: false
    };
  },
  mounted: function() {
    // 取数据
    this.getTableList();
  },
  methods: {
    // 获取订单列表
    getTableList: function() {
      this.renderTable(1);
      return;
    },
    changeDate(val) {
      this.formItem.datetime = val;
    },

    // 分页
    changePage() {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },

    cancelorder: function(index) {
      // 弹出确认框
      //   this.$Modal.confirm({
      //     title: "警告",
      //     content: "<p>此操作不可恢复，三思而后行...</p>",
      //     onOk: () => {
      //       this.$api.madeorder.cancel({ id: index }).then(res => {
      //         if (res.code == 200) {
      //           this.renderTable(1);
      //         }
      //       });
      //     }
      //   });
    },
    perChange: function(index) {
      this.logistics_id = index.value;
      this.logistics_name = index.label;
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.current = 1;
      }
      var pay_begin_at =
        this.formItem.datetime[0] != undefined ? this.formItem.datetime[0] : "";
      var pay_end_at =
        this.formItem.datetime[1] != undefined ? this.formItem.datetime[1] : "";
      let params = {
        page: this.pages.current,
        size: this.pages.size,
        key: this.formItem.key,
        phone: this.formItem.phone,
        good_name: this.formItem.title,
        order_status: this.formItem.order_status,
        pay_begin_at: pay_begin_at,
        pay_end_at: pay_end_at
      };
      this.$api.mangheorder.recoveryOrderList(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },

    exportOrder() {
      this.exportLoading = true;
      var pay_begin_at =
        this.formItem.datetime[0] != undefined ? this.formItem.datetime[0] : "";
      var pay_end_at =
        this.formItem.datetime[1] != undefined ? this.formItem.datetime[1] : "";
      this.$api.mangheorder
        .exportrecoveryorder({
          pay_begin_at: pay_begin_at,
          pay_end_at: pay_end_at
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
          }
          this.exportLoading = false;
        });
    }
  }
};
</script>

<style scoped>
</style>